import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpDeskFeatureComponent } from './feature/help-desk-feature.component';
import { UIRouterModule } from '@uirouter/angular';
import { HelpDeskRoute } from './help-desk.route';
import { HelpDeskComponent } from './presenters';
import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [HelpDeskFeatureComponent, HelpDeskComponent],
  imports: [
    CommonModule,
    SharedModule,
    UIRouterModule.forChild({
      states: [HelpDeskRoute]
  })

  ]
})
export class HelpDeskModule { }
